import { useQuery } from "react-query";
import { QueryKeys } from "./query-client";
import { useFirebaseAuth } from "../firebase/useFirebaseAuth";

export function useJWT() {
  const { auth } = useFirebaseAuth();

  const { data: jwt, isLoading: jwtIsLoading } = useQuery(
    [QueryKeys.JWT],
    () => getToken(),
    {
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
      refetchInterval: 300000, // 5 min
    }
  );

  function getToken(): Promise<string | null> {
    return new Promise((resolve, reject) => {
      auth.onAuthStateChanged(
        async (user) => {
          const tokenResult = await user?.getIdTokenResult();
          if (tokenResult && tokenResult.claims["user"]) {
            resolve((await tokenResult).token);
          } else {
            resolve(null);
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  return { jwt, jwtIsLoading };
}
